import { useRef } from "react"
import { ANIMATE_DELAY } from "src/libs/interfaces/animated"
import { ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"

/* Protopia Ecosystem component */
export interface IDelimiterAnimationContentProps {
   section: ILandingSection
   children: JSX.Element
}
const DelimiterAnimationContent = (props: IDelimiterAnimationContentProps): JSX.Element => {
    const section = props.section   
    const animated_delay =  section.delimiter?.animated_delay === ANIMATE_DELAY.WATERFALL
        ?
        0
        :
        section.delimiter?.animated_delay || ""
    const ref = useRef(null)
    useAnimated( ref, animated_delay ) 
    /* css class .landing-edit-cont - edit.select container for get bounds */
    const animate   = useAnimatedStyle(section.delimiter, 0)
    return <div className={`landing-delimiter-animation-content ${animate} `} ref={ref}>
       {props.children}
    </div>
}
export default DelimiterAnimationContent